<template>
  <div id="student-scholarship-list" class="premium-layout">
    <v-dialog v-model="previewRecordPrompt" persistent max-width="80%">
      <student-scholarship-preview
        pageDescription="Student scholarship preview"
        :previewRecordPrompt="previewRecordPrompt"
        @hidePreviewRecordPrompt="hidePreviewRecordPrompt()"
        :recordData="selectedData"
        v-if="previewRecordPrompt"
      ></student-scholarship-preview>
    </v-dialog>
    <v-card elevation="0" class="page-header-card mb-8">
      <v-card-title class="header-gradient pa-6">
        <div
          class="header-content d-flex flex-column flex-md-row align-center justify-space-between w-100 px-md-4"
        >
          <div
            class="header-title-section d-flex align-center mb-4 mb-md-0 pt-2 pt-md-0 text-center text-md-left"
          >
            <div
              class="icon-box mr-4 d-none d-sm-flex align-center justify-center"
            >
              <v-icon color="white" size="28">mdi-school</v-icon>
            </div>
            <div class="title-text">
              <h2 class="page-title mb-0">{{ PageTitle }}</h2>
              <div class="page-subtitle">
                {{ PageDescription }} - {{ YearName }}
              </div>
            </div>
          </div>

          <div
            class="header-actions d-flex flex-column flex-sm-row align-center w-100 w-md-auto"
          >
            <v-btn
              v-if="CreateButtonFlag"
              color="#56BDA3"
              to="/student-scholarship/create"
              elevation="6"
              large
              rounded
              class="action-btn apply-btn white--text px-6 w-100 w-sm-auto mb-3 mb-sm-0"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Apply for Scholarship
            </v-btn>
            <v-btn
              v-else
              color="primary"
              elevation="30"
              rounded
              class="action-btn apply-btn white--text px-6 w-100 w-sm-auto mb-3 mb-sm-0"
              @click="showNotEligibleWarning"
            >
              Apply for scholarship
            </v-btn>

            <v-btn
              @click.prevent="pageData"
              color="white"
              outlined
              rounded
              large
              class="action-btn refresh-btn ml-sm-3 w-100 w-sm-auto"
            >
              <v-icon left size="20">mdi-refresh-circle</v-icon>
              Refresh
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-card-text class="pa-6">
        <!-- Loading Indicator -->
        <div
          class="d-flex justify-center align-center py-12"
          v-if="LoadingFlag"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
            width="6"
          ></v-progress-circular>
        </div>
        <v-card elevation="0" class="filter-card mb-8">
          <v-card-text class="pa-4 px-6">
            <v-row align="end" no-gutters>
              <v-col cols="12" sm="5" md="4" lg="3">
                <div class="filter-group pr-md-4">
                  <div class="d-flex align-center mb-2">
                    <v-icon color="primary" size="18" class="mr-2"
                      >mdi-calendar-search</v-icon
                    >
                    <label class="field-label mb-0">Select Academic Year</label>
                  </div>
                  <v-autocomplete
                    :items="JciYearCodeOptions"
                    v-model="JciYearCode"
                    dense
                    outlined
                    hide-details
                    placeholder="Search Year"
                    class="modern-select-compact"
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-spacer class="d-none d-sm-block"></v-spacer>
              <v-col cols="12" sm="4" md="auto" v-if="rows.length > 0">
                <json-excel
                  v-if="DownloadFlag == 1"
                  :data="rows"
                  :fields="ExcelFields"
                  :name="ExcelFileName"
                >
                  <v-btn
                    color="#EDBE38"
                    elevation="0"
                    class="white--text font-weight-bold px-6"
                    height="40"
                    rounded
                  >
                    <v-icon left size="18">mdi-file-excel-box</v-icon>
                    Export to Excel
                  </v-btn>
                </json-excel>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- Statistics Cards -->
        <v-row class="mb-8" v-if="CardContent.length > 0">
          <v-col
            v-for="(row, index) in CardContent"
            :key="index"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card
              class="stat-card"
              elevation="4"
              :style="{ backgroundColor: row.CardBgColor }"
            >
              <v-card-text class="pa-6">
                <div class="stat-content">
                  <h1 class="stat-number mb-2">{{ row.Title }}</h1>
                  <h4 class="stat-label mb-4">{{ row.Description }}</h4>

                  <div class="stat-details">
                    <div class="stat-detail-row mb-3" v-if="row.SubTitleText1">
                      <v-icon
                        class="mr-2"
                        size="24"
                        :color="row.SubTitleIconColor1"
                      >
                        {{ row.SubTitleIconName1 }}
                      </v-icon>
                      <span class="stat-detail-text">
                        {{ row.SubTitleText1 }} {{ row.SubTitleDescription1 }}
                      </span>
                    </div>
                    <div class="stat-detail-row" v-if="row.SubTitleText2">
                      <v-icon
                        class="mr-2"
                        size="24"
                        :color="row.SubTitleIconColor2"
                      >
                        {{ row.SubTitleIconName2 }}
                      </v-icon>
                      <span class="stat-detail-text">
                        {{ row.SubTitleText2 }} {{ row.SubTitleDescription2 }}
                      </span>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- Data Table -->
        <v-card elevation="0" class="data-table-card" v-if="rows.length > 0">
          <v-card-title class="table-header pb-3">
            <v-icon left color="primary" size="28">mdi-table</v-icon>
            <span class="table-title">Scholarship Applications</span>
            <v-spacer></v-spacer>
            <v-chip color="primary" outlined small>
              <v-icon left small>mdi-counter</v-icon>
              {{ rows.length }} Records
            </v-chip>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-6">
            <v-container class="py-0">
              <v-row wrap>
                <v-col cols="12">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search applications by name, student ID, or status..."
                    single-line
                    outlined
                    dense
                    clearable
                    hide-details
                    class="search-field mb-6"
                  ></v-text-field>

                  <v-data-table
                    class="professional-table elevation-2"
                    v-model="selected"
                    :headers="tableColumns1"
                    :items="rows"
                    :items-per-page="50"
                    :search="search"
                    item-key="MemberId"
                    :single-select="false"
                    :show-select="false"
                    :footer-props="{
                      'items-per-page-options': [10, 20, 30, 40, 50],
                    }"
                  >
                    <template
                      v-slot:[`item.StudentApprovalStatusTxt`]="{ item }"
                    >
                      <v-chip
                        small
                        :color="item.StudentApprovalStatusColor"
                        dark
                        class="font-weight-bold"
                        >{{ item.StudentApprovalStatusTxt }}</v-chip
                      >
                    </template>
                    <template v-slot:[`item.ScholarshipStatusTxt`]="{ item }">
                      <v-chip
                        small
                        :color="item.ScholarshipStatusColor"
                        dark
                        class="font-weight-bold"
                        >{{ item.ScholarshipStatusTxt }}</v-chip
                      >
                    </template>
                    <template v-slot:[`item.PhotoPath`]="{ item }">
                      <v-avatar size="80" class="my-2">
                        <img :src="item.PhotoPath" alt="Student Photo" />
                      </v-avatar>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <div class="action-buttons">
                        <v-tooltip bottom v-if="item.PreviewFlag">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              color="primary"
                              @click="previewData(item, e)"
                              v-bind="attrs"
                              v-on="on"
                              class="mx-1"
                            >
                              <v-icon size="20">mdi-file-search</v-icon>
                            </v-btn>
                          </template>
                          <span>Preview Application</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="item.EditFlag">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              color="warning"
                              @click="editData(item, e)"
                              v-bind="attrs"
                              v-on="on"
                              class="mx-1"
                            >
                              <v-icon size="20">mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit Application</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="item.DeleteFlag">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              color="error"
                              @click="deleteConfirmAlert(item, e)"
                              v-bind="attrs"
                              v-on="on"
                              class="mx-1"
                            >
                              <v-icon size="20">mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete Application</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import StudentScholarshipPreview from "@/view/pages/erp/student-scholarship/StudentScholarshipPreview.vue";
import Swal from "sweetalert2";

export default {
  components: { StudentScholarshipPreview },

  mixins: [common],
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SearchButtonFlag: false,
      CreateButtonFlag: false,
      SubmitFlag: false,
      SpeedDialFlag: false,
      rows: [],
      tableColumns1: [],
      selected: [],
      search: "",
      CardContent: [],

      DownloadFlag: 1,
      ExcelFileName: "",
      ExcelFields: "",

      recordToEdit: "",
      record: {},
      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      editPageDescription: "Assign LO President for JCI India",

      LomDataPageTitle: "",
      LomDataPreviewFlag: false,
      LomDataParams: {},

      selectedData: {},
      tableData1: {},

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      zone: {},
      lom: {},

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  mounted() {
    /*
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Vuetify", route: "alerts" },
        { title: "Form Inputs & Control", route: "autocompletes" },
        { title: "Fileinptus" },
      ]);
      */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    JciYearCode: function () {
      console.log("watch JciYearCode");
      var JciYearCode = this.JciYearCode;
      console.log({ JciYearCode });
      if (JciYearCode > 0) {
        this.getCardDetails();
        this.searchForm();
      } else {
        this.rows = [];
        this.CreateButtonFlag = false;
        this.CardContent = [];
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "student_scholarship",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    editData(tr) {
      console.log("editData called");
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1);

      if (n1 > 0) {
        var url = "/student-scholarship/edit";
        var id = tr.StudentId;
        console.log("id=" + id);
        var params = {
          id: id,
        };
        this.pageRedirect(params, url);
      } else {
        var message = "Kindly select one event to edit";
        this.toast("error", message);
      }
    },
    pageData() {
      console.log("pageData called");
      this.getJciYearCodeOptions();
      this.getCardDetails();
      this.searchForm();
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    deleteConfirmAlert(tr) {
      console.log("deleteConfirmAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var htmlTxt = "";
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: "Delete",
          confirmButtonColor: "#d33",
          cancelButtonText: "Cancel",
          cancelButtonColor: "#b2a496",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleteData(tr);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        if (n1 == 0) {
          message += "Kindly select one record to delete. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    showNotEligibleWarning() {
      Swal.fire({
        icon: "warning",
        title: "Not Eligible",
        text: "You are not eligible to apply for this scholarship.",
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
      });
    },
    deleteData(tr) {
      console.log("deleteData is called");
      console.log({ tr });

      var id = tr.StudentId;
      console.log({ id });

      // id = 0;
      if (id > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/destroy";
        var upload = {
          UserInterface: 1,
          StudentId: id,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = true;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.searchForm();
              thisIns.LoadingFlag = false;
            } else {
              thisIns.sweetAlert("error", output, false);
              thisIns.LoadingFlag = false;
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            // thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Kindlly select one Ledger to delete. ";
        this.sweetAlert("error", message, false);
      }
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/lom/create";
      var params = {};
      this.pageRedirect(params, url);
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      this.searchForm();
    },
    showLomDataPreview(tr) {
      console.log("showLomDataPreview called");
      console.log({ tr });
      this.LomDataPageTitle = tr.LomName + " information for the current year";
      this.LomDataPreviewFlag = true;
      this.LomDataParams = {
        UserInterface: 2,
        LomCode: tr.LomId,
      };
    },
    hideLomDataPreview() {
      console.log("hideLomDataPreview called");
      this.LomDataPreviewFlag = false;
      this.LomDataParams = {};
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      console.log(flag);
      if (flag) {
        this.searchForm();
      }
    },
    editAlert(tr) {
      console.log("editAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var LomId = tr.LomId;
        console.log("LomId=" + LomId);
        this.record = tr;
        this.recordToEdit = LomId;
        this.editPageDescription = " LO President for " + tr.LomName;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one record to modifiy";
        this.toast("error", message);
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    getJciYearCodeOptions() {
      this.LoadingFlag = true;
      this.JciYearCodeOptionsLoading = true;
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    searchForm() {
      console.log("searchForm is called");

      var YearCode = this.JciYearCode;
      console.log({ YearCode });

      if (YearCode > 0) {
        this.SearchFlag = true;
        this.rows = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/lists";
        var upload = {
          UserInterface: 1,
          Year: this.JciYearCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = [];
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.TableContent;
            console.log({ records });

            thisIns.tableColumns1 = records.TableHeader;
            thisIns.ta = records.TableOptions;

            if (flag == 1) {
              thisIns.rows = records.TableData;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
    getCardDetails() {
      console.log("getCardDetails is called");

      // var validate1 = this.$refs.form2.validate();
      var validate1 = true;

      var YearCode = this.JciYearCode;
      console.log({ YearCode });

      if (YearCode > 0) {
        this.SearchFlag = true;
        this.CreateButtonFlag = false;
        this.CardContent = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/scholarship-info";
        var upload = {
          UserInterface: 1,
          Year: YearCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = [];
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            thisIns.CreateButtonFlag = records.CreateButtonFlag;

            if (flag == 1) {
              thisIns.CardContent = records.CardContent;
              //   thisIns.toast("success", output);
            } else {
              console.log("error=" + output);
              //   thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Year is required";
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* Professional Modern UI Styles for StudentScholarshipList */
:root {
  --jci-navy: #3a67b1;
  --jci-aqua: #0097d7;
  --jci-gold: #edbe38;
  --jci-seaform: #56bda3;
  --glass-bg: rgba(255, 255, 255, 0.8);
}

#student-scholarship-list {
  background: linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%);
  min-height: 100vh;
  padding: 24px;
  font-family: "Outfit", "Inter", sans-serif;

  /* Page Header with Gradient */
  .page-header-card {
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(58, 103, 177, 0.12) !important;
  }

  .header-gradient {
    background: linear-gradient(
      135deg,
      var(--jci-navy) 0%,
      var(--jci-aqua) 60%,
      var(--jci-seaform) 100%
    );
    color: white !important;
    position: relative;
    overflow: hidden;
    min-height: 100px;

    &::after {
      content: "";
      position: absolute;
      top: -30%;
      right: -5%;
      width: 300px;
      height: 300px;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 70%
      );
      border-radius: 50%;
      pointer-events: none;
    }
  }

  .header-content {
    position: relative;
    z-index: 2;
  }

  .icon-box {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(8px);
    width: 48px;
    height: 48px;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  .page-title {
    color: white !important;
    font-size: 24px !important;
    font-weight: 800 !important;
    margin: 0;
    letter-spacing: -0.5px;
  }

  .page-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    font-weight: 600;
  }

  .action-btn {
    font-weight: 700 !important;
    letter-spacing: 0.3px;
    font-size: 14px !important;
    height: 44px !important;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15) !important;
    }

    &.apply-btn {
      background: var(--jci-seaform) !important;
    }

    &.refresh-btn {
      background: rgba(255, 255, 255, 0.15) !important;
      backdrop-filter: blur(4px);
      border: 1px solid rgba(255, 255, 255, 0.3) !important;
    }
  }

  /* Statistics Cards */
  .stat-card {
    border-radius: 16px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    border: none !important;
    overflow: hidden;
    min-height: 160px;
    /* Reduced card size */

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.2) 0%,
        transparent 100%
      );
      pointer-events: none;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15) !important;
    }
  }

  .stat-icon-wrapper {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(8px);
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 12px !important;
  }

  .stat-number {
    font-size: 28px !important;
    /* Smaller card title */
    font-weight: 800 !important;
    letter-spacing: -0.5px;
    color: white !important;
    margin-bottom: 4px !important;
  }

  .stat-label {
    font-size: 15px !important;
    /* Smaller label */
    font-weight: 600 !important;
    color: white !important;
    opacity: 0.9;
    letter-spacing: 0.5px;
    margin-bottom: 12px !important;
  }

  .stat-details {
    margin-top: 12px;
    padding-top: 12px;
    color: white !important;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  .stat-detail-text {
    font-size: 14px;
    font-weight: 600;
  }

  /* Data Table Card */
  .data-table-card {
    border-radius: 16px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06) !important;
  }

  .table-header {
    background: white;
    padding: 20px 24px !important;

    .table-title {
      font-size: 20px;
      font-weight: 700;
      color: var(--jci-navy);
    }
  }

  .search-field {
    .v-input__slot {
      border-radius: 16px !important;
      background: #f8fafc !important;
      border: 2px solid transparent !important;
      transition: all 0.3s ease;
      padding: 0 20px !important;

      &:hover {
        border-color: var(--jci-aqua) !important;
      }
    }

    &.v-input--is-focused .v-input__slot {
      background: white !important;
      border-color: var(--jci-navy) !important;
      box-shadow: 0 10px 25px rgba(58, 103, 177, 0.1) !important;
    }
  }

  /* Professional Table Styling */
  .professional-table {
    border-radius: 16px !important;

    .v-data-table-header {
      background: #f1f5f9 !important;

      th {
        font-weight: 800 !important;
        font-size: 14px !important;
        color: var(--jci-navy) !important;
        padding: 20px !important;
        border-bottom: none !important;
      }
    }

    tbody tr {
      &:nth-child(even) {
        background-color: #fafbfd;
      }

      &:hover {
        background-color: #f1f7ff !important;
        cursor: pointer;
      }

      td {
        padding: 20px !important;
        font-weight: 500;
        color: #334155;
      }
    }

    .v-avatar {
      border: 4px solid white;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  /* Chip Styling */
  .v-chip {
    padding: 0 12px !important;
    font-size: 12px !important;
    height: 28px !important;
    border-radius: 8px !important;
  }

  /* Action Buttons */
  .action-buttons {
    .v-btn--icon {
      background: #f8fafc;
      margin: 0 4px;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        transform: translateY(-2px);

        &.primary--text {
          background: rgba(58, 103, 177, 0.1);
        }

        &.warning--text {
          background: rgba(237, 190, 56, 0.1);
        }

        &.error--text {
          background: rgba(255, 0, 0, 0.1);
        }
      }
    }
  }

  /* Animations */
  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .stat-card,
  .filter-card,
  .data-table-card {
    animation: slideInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
  }

  /* Page Description Banner */
  .page-description-banner {
    background: #f8fafc;
    border-bottom: 1px solid #eef2f7;
    display: flex;
    align-items: center;

    .description-text {
      font-size: 13px;
      font-weight: 500;
      color: #64748b;
    }
  }

  /* Compact Select */
  .modern-select-compact {
    .v-input__slot {
      border-radius: 8px !important;
      background: #fff !important;
      border: 1px solid #e2e8f0 !important;
      transition: all 0.2s ease;
      min-height: 40px !important;

      &:hover {
        border-color: var(--jci-aqua) !important;
      }
    }
  }

  .stat-card:nth-child(1) {
    animation-delay: 0.1s;
  }

  .stat-card:nth-child(2) {
    animation-delay: 0.2s;
  }

  .stat-card:nth-child(3) {
    animation-delay: 0.3s;
  }

  /* Responsive Adjustments */
  @media (max-width: 960px) {
    padding: 16px;

    .page-title {
      font-size: 20px !important;
    }

    .header-gradient {
      padding: 24px 16px !important;
    }

    .stat-number {
      font-size: 24px !important;
    }
  }

  @media (max-width: 600px) {
    padding: 10px;

    .header-content {
      padding: 0 !important;
      position: relative;
      z-index: 2;
    }

    .header-title-section {
      flex-direction: column;
      gap: 8px;
    }

    .header-actions {
      width: 100%;
      position: relative;
      z-index: 5;
    }

    .action-btn {
      width: 100%;
      margin-left: 0 !important;
      position: relative;
      z-index: 5;
      pointer-events: auto;
    }

    .filter-card {
      .v-card-text {
        padding: 16px !important;
      }

      .row {
        flex-direction: column;
        align-items: stretch !important;
      }

      .col {
        width: 100%;
        padding: 8px 0 !important;
      }

      .field-label {
        margin-bottom: 8px;
      }
    }

    .page-description-banner {
      padding: 10px 16px !important;

      .description-text {
        font-size: 12px;
      }
    }

    .table-header {
      flex-direction: column;
      align-items: flex-start !important;
      gap: 12px;
      padding: 16px !important;

      .table-title {
        font-size: 18px;
      }
    }

    .professional-table {
      .v-data-table-header th {
        font-size: 12px !important;
        padding: 12px !important;
      }

      tbody td {
        padding: 12px !important;
        font-size: 13px !important;
      }
    }
  }
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f4f8;
}

::-webkit-scrollbar-thumb {
  background: var(--jci-aqua);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--jci-navy);
}
</style>